import { getCurrentUser } from '@aws-amplify/auth';
import { useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useDebounce } from 'use-debounce';

import { Routes } from '@/router/routes';

import { useCurrentUser } from '../store';

export function AuthGate({ children }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  //  NOTE this is a solution to prevent flickering of the page while redirecting
  const [isAppLoading] = useDebounce(isLoading, 600);

  const { setCurrentUser } = useCurrentUser();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const user = await getCurrentUser();
        setCurrentUser(user);

        const isHomeOrSignIn = [Routes.Home, Routes.SignIn].includes(
          pathname as Routes
        );

        navigate(isHomeOrSignIn ? Routes.Models : pathname);
      } catch (error) {
        navigate(Routes.SignIn);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (isAppLoading) {
    return (
      <div className="w-screen h-screen flex items-center justify-center">
        <span className="font-bold text-3xl">1 of 1 Admin...</span>
      </div>
    );
  }

  return children;
}
